import ReactTable from "../../components/react-table/order-maintenance";

function MaintenanceOrdenCompra() {
  return (
    <div>
      <ReactTable contextmenu="mantiene" />
    </div>
  );
}

export default MaintenanceOrdenCompra;
